export default "__VITE_ASSET__DehkrCeQ__"